import ReactDOM from "react-dom"
import SwaggerUI from "swagger-ui-react"
import "swagger-ui-react/swagger-ui.css"

const App = () => <SwaggerUI url='/openapi.yaml' />

const app = document.getElementById("root")
ReactDOM.render(<App />, app)
